<template>
  <div class="form-group">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'va-form-group',
  created () {

  }
}
</script>



// WEBPACK FOOTER //
// VAFormGroup.vue?745a1c94